var render = function render(){var _vm=this,_c=_vm._self._c;return _c('li',{staticClass:"login-sns-each facebook"},[_c('a',{attrs:{"href":"#"},on:{"click":function($event){$event.preventDefault();return _vm.loginFacebook()}}},[_c('span',{staticClass:"icon-sns icon-facebook"}),_c('span',{staticClass:"a11y-hidden"},[_vm._v("페이스북으로 로그인")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }